// Simple function to check if the current time is after noon
const isAfterNoon = (): boolean => {
  const now = new Date();
  const noon = new Date(now);
  noon.setHours(12, 0, 0, 0);
  return now > noon;
};

// Time format function used to pass valid times into input forms
const formatTimeToHHMM = (date: Date): string => {
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

export { isAfterNoon, formatTimeToHHMM };
